import styled from 'styled-components'

import { ClinTheme } from '../../ClinTheme'
import { ClinTableRow } from '../../components/ClinTable/ClinTable'

export const StyledClinTableRow = styled(ClinTableRow)({
  background: ClinTheme.colors.white
})

export const StyledColoredText = styled.span({
  color: ClinTheme.colors.primaryMid
})
